// AdminPage.jsx - Admin kontrol paneli
import React, { useState } from 'react';
import Layout from '../components/common/Layout';
import AdminReceiptPanel from '../components/admin/AdminReceiptPanel';
import AdminRecurringEvents from '../components/admin/AdminRecurringEvents';
import AdminWeeklySchedule from '../components/admin/AdminWeeklySchedule';
import AdminUserManagement from '../components/admin/AdminUserManagement';
import AdminEvents from '../components/admin/AdminEvents';
import AdminAccessCodes from '../components/admin/AdminAccessCodes';
import AdminPhotoHistory from '../components/admin/AdminPhotoHistory';
import AdminFeedback from '../components/admin/AdminFeedback';
import AdminTeamMembers from './admin/AdminTeamMembers';
import Card from '../components/common/Card';

const AdminPage = () => {
  const [activeTab, setActiveTab] = useState('receipts');

  const tabs = [
    { id: 'receipts', name: 'Dekont Onayları', icon: '📄' },
    { id: 'feedback', name: 'Geri Bildirimler', icon: '💬' },
    { id: 'schedule', name: 'Haftalık Saatler', icon: '📅' },
    { id: 'recurring', name: 'Tekrarlayan Dersler', icon: '🔁' },
    { id: 'events', name: 'Etkinlikler', icon: '🎉' },
    { id: 'access-codes', name: 'Kapı Kodları', icon: '🔐' },
    { id: 'photos', name: 'Fotoğraf Geçmişi', icon: '📷' },
    { id: 'team', name: 'Ekip Üyeleri', icon: '👤' },
    { id: 'users', name: 'Kullanıcı Yönetimi', icon: '👥' },
    { id: 'stats', name: 'İstatistikler', icon: '📊' }
  ];

  return (
    <Layout>
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="flex items-center mb-8 fade-in">
          <svg className="w-8 h-8 text-purple-300 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
          </svg>
          <h1 className="text-3xl font-bold text-white bg-clip-text text-transparent bg-gradient-to-r from-purple-200 to-pink-200">
            Admin Kontrol Paneli
          </h1>
        </div>

        {/* Tabs */}
        <div className="flex space-x-2 mb-6 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`
                px-6 py-3 rounded-lg font-semibold whitespace-nowrap transition-all duration-200
                ${activeTab === tab.id
                  ? 'bg-blue-600 text-white shadow-lg'
                  : 'bg-gray-800 text-gray-400 hover:bg-gray-700 hover:text-white'
                }
              `}
            >
              <span className="mr-2">{tab.icon}</span>
              {tab.name}
            </button>
          ))}
        </div>

        {/* Tab Content */}
        <div className="fade-in">
          {activeTab === 'receipts' && <AdminReceiptPanel />}
          
          {activeTab === 'feedback' && <AdminFeedback />}
          
          {activeTab === 'schedule' && <AdminWeeklySchedule />}
          
          {activeTab === 'recurring' && <AdminRecurringEvents />}
          
          {activeTab === 'events' && <AdminEvents />}
          
          {activeTab === 'access-codes' && <AdminAccessCodes />}
          
          {activeTab === 'photos' && <AdminPhotoHistory />}
          
          {activeTab === 'team' && <AdminTeamMembers />}
          
          {activeTab === 'users' && <AdminUserManagement />}
          
          {activeTab === 'stats' && (
            <Card>
              <h2 className="text-2xl font-bold text-white mb-6">İstatistikler</h2>
              <div className="text-center py-12">
                <p className="text-gray-400">Bu özellik henüz geliştirilmekte...</p>
                <p className="text-sm text-gray-500 mt-2">Faz 5'te eklenecek</p>
              </div>
            </Card>
          )}
        </div>
      </div>
    </Layout>
  );
};

export default AdminPage;
